import gql from 'graphql-tag';

export const QueryItemFragment = gql`
  fragment QueryItemFragment on TaskModel {
    id
    name
    text
    image
    link
    link_title
    amount
    days
    products
    fileItem {
      cacheItem {
        filePath # картинка  товара
      }
    }
  }
`;

const QueryTaskPeopleFragment = gql`
  fragment QueryTaskPeopleFragment on TaskPeopleModel {
    id
    status_id
    taskStatusItem {
      id
      title
      color
    }
    taskItem {
      ...QueryItemFragment
    }
  }
  ${QueryItemFragment}
`;

export default {
  getTaskById: gql`
    query getTaskById($taskId: Int!) {
      getTaskById(taskId: $taskId) {
        ...QueryTaskPeopleFragment
      }
    }
    ${QueryTaskPeopleFragment}
  `,
  toProgress: gql`
    mutation addTaskToProgress($id: Int!) {
      addTaskToProgress(taskId: $id) {
        success
        info
        warning
        error
        errorCode
      }
    }
  `,
  list: gql`
    query getTasks {
      getTasks(imageSizeFilter: "h600") {
        success
        info
        warning
        error
        errorCode
        task {
          access {
            ...QueryItemFragment
          }
          progress {
            ...QueryItemFragment
            daysLeft
          }
          complete {
            ...QueryItemFragment
          }
        }
      }
    }
    ${QueryItemFragment}
  `,
  getPeopleActiveTasksCount: gql`
    query getPeopleActiveTasksCount {
      getPeopleActiveTasksCount
    }
  `,
  sendClaim: gql`
    query sendClaim(
      $INN: String
      $name: String
      $companyName: String
      $KPP: String
      $files: [String!]
      $phone: String
      $text: String
      $email: String
    ) {
      sendClaim(
        INN: $INN
        name: $name
        companyName: $companyName
        KPP: $KPP
        files: $files
        phone: $phone
        text: $text
        email: $email
      ) {
        error
        success
        info
      }
    }
  `
};
